@if (_progressService.isLoading()) {
  <du-config-overview-skeleton></du-config-overview-skeleton>
} @else {
  @if (toolbarConfig()) {
    <du-overview-toolbar
      [config]="toolbarConfig()!"
      [view]="viewType()"
      (primaryClick)="onPrimaryClick()"
      (secondaryClick)="onSecondaryClick()"
      (searchChange)="searchInput.set($event)"
      (filterChange)="onFilterChange($event)"
      (filterRemoved)="onFilterRemoved($event)"
      (filtersCleared)="onFiltersCleared()"
      (viewChange)="toggleViewType($event)"
    />

    <div class="overview-body">
      @if (viewType() === 'grid') {
        @if (filteredCards().length > 0 || overviewModel()?.buttons?.length) {
          <div class="overview-grid-wrapper">
            <div class="card-container">
              @for (card of paginatedCards(); track card.id) {
                <du-config-card [disabled]="shouldDisableCard(card)" [content]="card"></du-config-card>
              }
            </div>
            @if (filteredCards().length > 0) {
              <p-paginator
                class="overview-grid-paginator"
                [first]="first()"
                [rows]="rows()"
                [totalRecords]="filteredCards().length"
                [rowsPerPageOptions]="[12, 24, 48, 96]"
                (onPageChange)="onPageChange($event)"
                [showCurrentPageReport]="true"
                [currentPageReportTemplate]="'paginator.report' | translate"
              />
            }
          </div>
        } @else {
          <du-config-overview-empty />
        }
      } @else {
        @if (overviewModel()!.table.data.length > 0) {
          <div class="list-container">
            <du-config-table
              [configTable]="overviewModel()!.table"
              [searchInput]="searchInput()"
            ></du-config-table>
          </div>
        } @else {
          <du-config-overview-empty />
        }
      }
    </div>
  }
}
